export default __webpack_public_path__ + "static/media/mandaue.a689bd55.jpg";